import { useState } from "react";
import { SmartSoftButton, SmartSoftForm, SmartValid } from "soft_digi";
// import { isEmptyObject } from "../../../services/core/CommonService";
import { ValidateFormNew } from "soft_digi/dist/services/smartValidationService";
import { ORDER_ITEMS_URLS } from "../../../api/OrderUrls";
import { useSiteContext } from "../../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../../services/notifyService";
import { post } from "../../../services/smartApiService";

const OrderCancellation = ({ id, loadOrderData }) => {
  const [formData, setFormData] = useState({});
  const [formSubmit, setFormSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState(false);
  const { setLoading, closeModal,refreshUser } = useSiteContext();

  const handleInputChange = (name, value) => {
    //console.log(" name " ,name , "   value " , value)
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleErrorChange = (name, value) => {
    // console.log(" name ", name, "   value ", value);
    setFormErrors((prev) => {
      // Create a copy of the previous state
      const updatedFormData = { ...prev };
      // Check if the value is null or empty
      if (value === null || value === "") {
        // If true, remove the property from the updated state
        delete updatedFormData[name];
      } else {
        // Otherwise, update or add the property in the updated state
        updatedFormData[name] = value;
      }

      return updatedFormData;
    });
  };

  const handleError = (errorMessage) => {
    showAlertAutoClose(errorMessage, "error");
    setLoading(false);
  };

  const handleFormSubmit = () => {
  
    setFormSubmit(true);
    if (!ValidateFormNew(formData,formElements)) {
      return false;
    }
    setLoading(true, "Processing....Please Wait");
    let url = ORDER_ITEMS_URLS.UPDATE_CANCEL;
    let data_in = { ...formData, id: id };
    const subscription = post(url, data_in, handleError).subscribe(
      (response) => {
        setFormSubmit(false);
        showAlertAutoClose(
          "Cancellation Request Submitted successfully",
          "success"
        );
        setLoading(false);
        loadOrderData();
        closeModal();
        refreshUser()
        window.scrollTo(0, 0);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const Validations = {
    status: [SmartValid.required("Status is Required")],
    remarks: [SmartValid.required("Remarks is Required")],
  };

  const options = [
    { value: "Order By Mistake", label: "Order By Mistake" },
    { value: "Change of Mind", label: "Change of Mind" },
    { value: "Others", label: "Others" },
  ];
  const formElements = [
    {
      type: "SELECT_BOX",
      width: "12",
      name: "status",
      element: {
        label: "Status",
        isRequired:true,
        validations: Validations.status,
        options: options,
      },
      hideFunction:(data)=>{
        // console.log("formdata " , formData)
        return formData.status && formData.status.value && formData.status.value==="Others" ?  true:false;
      }
    },
    {
      type: "TEXTAREA",
      width: "12",
      name: "remarks",
      element: {
        label: "Remarks",
        isRequired:true,
        max:"255",
        validations: Validations.remarks,
      },
      hideFunction:(data)=>{
        // console.log("formdata " , formData)
        return formData.status && formData.status.value && formData.status.value==="Others" ? false : true;
      }
    },
  ];

  return (
    <div>
      <div className="smart-customer-input">
        <div className="is-flex is-justify-content-space-between">
          <div className="is-size-4 has-text-weight-bold mt-4">
            Order Cancellation
          </div>
          <div className="mb-3" onClick={closeModal}>
            <div className="customer-modal-close mb-3 ">
              <i class="fa fa-times has-text-white" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div className="mb-3 m-6 pb-5">
          <SmartSoftForm
            formData={formData}
            setFormData={handleInputChange}
            elements={formElements}
            formSubmit={formSubmit}
            handleErrorChange={handleErrorChange}
          />
        </div>
        <div className="mb-3 is-flex is-justify-content-center">
          <SmartSoftButton
            label="Submit"
            classList={["smart-customer-primary-button"]}
            onClick={() => handleFormSubmit()}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderCancellation;
